/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification/src/modules/product-specification/./product-specification';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = (props) => {
    const {
        ProductSpecification,
        ProductSpecificationTableProps,
        ProductSpecificationTableBodyProps,
        productSpecificationResult
    } = props;
    return (
        <Module {...ProductSpecification}>
            {props.title}
            <Node {...ProductSpecificationTableProps}>
                <Node {...ProductSpecificationTableBodyProps}>
                    {productSpecificationResult &&
                        productSpecificationResult.map((row) => {
                            return removeUndefinedAttributes(row);
                        })}
                </Node>
            </Node>
        </Module>
    );
};

function removeUndefinedAttributes(row: JSX.Element | null): JSX.Element | null {
    if (
        (row?.props.cellData.props && !('dangerouslySetInnerHTML' in row?.props.cellData.props)) ||
        (row?.props.cellData.props.dangerouslySetInnerHTML?.__html !== undefined &&
            row?.props.cellData.props.dangerouslySetInnerHTML?.__html !== 'Not defined')
    ) {
        return row && row;
    }
    return null;
}

export default ProductSpecificationView;
